import script from "./MenuWithSmallMenus.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuWithSmallMenus.vue?vue&type=script&setup=true&lang=ts"

import "./MenuWithSmallMenus.vue?vue&type=style&index=0&id=13b32aac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b32aac"]])

export default __exports__